import * as v from "valibot";

import { rpcContract } from "../rpc";

export const updateProfileRpcContract = rpcContract({
  name: "updateProfile",
  paramsSchema: v.object({
    handle: v.optional(
      v.pipe(
        v.string(),
        v.minLength(3, "Handle must be at least 3 characters"),
        v.regex(
          /^[a-z0-9_\-.]+$/,
          "Handle can only contain lowercase letters, numbers, underscores, hyphens, and dots",
        ),
      ),
    ),
  }),
  resultSchema: v.undefined(),
});

export type UpdateProfileParams = v.InferOutput<(typeof updateProfileRpcContract)["paramsSchema"]>;
export type UpdateProfileResult = v.InferOutput<(typeof updateProfileRpcContract)["resultSchema"]>;
